// extracted by mini-css-extract-plugin
export default {"genericCard":"tp-z","inline":"up-z","mastercard":"vp-z","discover":"wp-z","visa":"xp-z","amex":"yp-z","active":"zp-z"};